import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Alert, alpha, Snackbar, styled } from '@mui/material';
import { pxToRem } from '@themes';
var StyledSnackbar = styled(Snackbar)(function (_ref) {
  var theme = _ref.theme;

  var styles = _defineProperty({
    marginTop: pxToRem(38),
    marginLeft: pxToRem(-8)
  }, theme.breakpoints.down('tablet'), {
    width: "calc(100% - ".concat(pxToRem(32), ")"),
    marginTop: pxToRem(28),
    marginLeft: pxToRem(-8),
    top: pxToRem(24),
    left: pxToRem(24),
    right: 'auto'
  });

  return styles;
});
var SnackbarAlert = styled(Alert)(function (_ref2) {
  var theme = _ref2.theme,
      severity = _ref2.severity;
  var styles = {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0.5, 2),
    minWidth: pxToRem(250),
    borderRadius: pxToRem(12),
    fontWeight: 500,
    fontSize: pxToRem(14),
    lineHeight: pxToRem(18)
  };

  switch (severity) {
    case 'success':
      {
        styles.border = "".concat(pxToRem(1), " solid ").concat(alpha(theme.palette.jewel.main, 0.2));
        styles.color = theme.palette.jewel.main;
        break;
      }

    case 'error':
      {
        styles.border = "".concat(pxToRem(1), " solid ").concat(alpha(theme.palette.maroonFlush.main, 0.2));
        styles.color = theme.palette.maroonFlush.main;
        break;
      }

    default:
      {
        break;
      }
  }

  return styles;
});
export { SnackbarAlert, StyledSnackbar };